import { faqItems } from '@/mocks/home';

export default function FAQ() {
  return (
    <section id="faq" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">关于丫丫漫画，你想知道的都在这里</p>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 font-heading text-lg shrink-0">Q</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-700 leading-relaxed pl-6">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}